import firebase from "firebase/app";
import "firebase/auth";
import state from "../store";

console.log(process.env.VUE_APP_FIREBASE_API_KEY);
var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};
console.log('test firebase.js', firebase.initializeApp)
const firebaseInstance = firebase.initializeApp(config);

export default firebaseInstance;

firebaseInstance.auth().onAuthStateChanged(user => {
  if (user) {
    state.commit("SET_LOGGED_IN", true);
    state.commit("SET_LOGGED_IN_LOADING", false);
  } else {
    state.commit("SET_LOGGED_IN", true);
    state.commit("SET_LOGGED_IN_LOADING", false);
  }
});
